// src/pages/Auth/ResetPassword.js
import { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import "../../styles/Login.css";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPw, setShowPw] = useState(false);

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!token) {
      setErr("Invalid reset link.");
    }
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");
    setErr("");

    if (!token) return;

    if (password.length < 8) {
      setErr("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setErr("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);
      const { data } = await axios.post(
        `${BASE_URL}/api/auth/reset-password/${token}`,
        { password: password.trim() },
        { headers: { "Content-Type": "application/json" } }
      );
      setMsg(data?.message || "✔️ Password reset successfully!");
      setTimeout(() => nav("/login"), 1200);
    } catch (e2) {
      setErr(e2?.response?.data?.message || "Invalid or expired link.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg">
      <div className="login-card">
        <h3 className="auth-title">Reset password</h3>

        <form onSubmit={submit} className="auth-form" noValidate>
          <label>New password</label>
          <div className="input-group">
            <input
              type={showPw ? "text" : "password"}
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
              placeholder="At least 8 characters"
              disabled={loading}
            />
            <button
              type="button"
              className="input-group-text"
              onClick={() => setShowPw((s) => !s)}
              aria-label={showPw ? "Hide password" : "Show password"}
              disabled={loading}
            >
              {showPw ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <label>Confirm Password</label>
          <input
            type={showPw ? "text" : "password"}
            className="form-control"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
            placeholder="Re-enter password"
            disabled={loading}
          />

          <button
            type="submit"
            className="btn btn-primary auth-submit"
            disabled={loading}
            style={{ marginTop: 10 }}
          >
            {loading ? "Updating…" : "Update password"}
          </button>
        </form>

        {err && <p className="auth-error">{err}</p>}
        {msg && (
          <p className="success" style={{ marginTop: 12 }}>
            {msg}
          </p>
        )}

        <div className="auth-links">
          Back to{" "}
          <Link to="/login" className="link-cta">
            Login
          </Link>
        </div>
      </div>
    </div>
  );
}
